module.exports = __webpack_public_path__ + "static/media/tex-trends-top-10-fw2324.6ce7c6eb.png";